import { SelectTabData, SelectTabEvent, Tab, TabList } from '@fluentui/react-components'
import {
  ClipboardTextLtr24Regular,
  Desktop24Regular,
  Organization20Regular,
  Organization24Regular,
  PeopleTeam24Regular,
  Person24Regular,
} from '@fluentui/react-icons'
import { useMemo, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { createRestClient } from '@/contexts/QueryProvider'
import { DataGridComponent } from '../../DataGrid/DataGridComponent'
import { AddOrganisationForm } from '../../Forms/AddOrganisationForm'
import { OverlayDrawerComponent } from '../../OverlayDrawerComponent/OverlayDrawerComponent'
import { OrganisationDetailsPanel } from '../OrganisationDetailsPanel'
import { OrganisationProjectsPanel } from '../OrganisationProjectsPanel'
import { OrganisationTeamsPanel } from '../OrganisationTeamsPanel'
import { OrganisationUserPanel } from '../OrganisationUserPanel'
import { OrganisationWorkspacesPanel } from '../OrganisationWorkspacesPanel'
import './SubscriptionControl.scss'
import { subscriptionTableColumns } from './subscriptionsTableColumns'
import { useSetHeaderContext } from '@/layouts/MainLayout/HeaderContext'
import { useSessionStorage } from '@/hooks'
import { isSuperUser } from '@/util'

export const SubscriptionControl = () => {
  const [searchParams, setSearchParams] = useSearchParams()

  const { getSubscriptionsApiGetOrganisations } = createRestClient()
  const { data: organisations, isPending, isError } = getSubscriptionsApiGetOrganisations.useQuery()
  const [addOrgDrawerOpen, setAddOrgDrawerOpen] = useState<boolean>(false)

  const orgId = useMemo(() => {
    return searchParams.get('orgId')
  }, [searchParams])

  const tab = useMemo(() => {
    return searchParams.get('tab')
  }, [searchParams])

  const onTabSelect = (_event: SelectTabEvent, data: SelectTabData) => {
    searchParams.set('tab', data.value as string)
    setSearchParams(searchParams)
  }

  const orgName = organisations?.find((x) => x.id.toString() === orgId)?.name
  useSetHeaderContext({
    rightTitle: orgName ? { text: orgName, icon: Organization20Regular } : undefined,
  })

  const [userRole] = useSessionStorage('roles', 1)
  const canAddOrg = isSuperUser(userRole)

  // TODO: Add loading and error states
  if (isPending) return null
  if (isError) return null

  return (
    <div className="subscriptions">
      {!orgId && !tab && (
        <div className="container">
          <DataGridComponent
            items={organisations}
            columns={subscriptionTableColumns}
            onAdd={canAddOrg ? () => setAddOrgDrawerOpen(true) : undefined}
          />
          <OverlayDrawerComponent
            open={addOrgDrawerOpen}
            setOpen={setAddOrgDrawerOpen}
            title="Add organisation"
            content={<AddOrganisationForm onSubmit={() => setAddOrgDrawerOpen(false)} />}
          />
        </div>
      )}
      {orgId && tab && (
        <div className="container">
          <TabList selectedValue={tab} onTabSelect={onTabSelect}>
            <Tab id="Conditions" icon={<Organization24Regular />} value="details">
              Details
            </Tab>
            <Tab id="Arrivals" icon={<Person24Regular />} value="users">
              Users
            </Tab>
            <Tab id="projects" icon={<ClipboardTextLtr24Regular />} value="projects">
              Projects
            </Tab>
            <Tab id="teams" icon={<PeopleTeam24Regular />} value="teams">
              Teams
            </Tab>
            <Tab id="workspaces" icon={<Desktop24Regular />} value="workspaces">
              Workspaces
            </Tab>
          </TabList>
          <div style={{ padding: '0px 10px' }}>
            {tab === 'details' && <OrganisationDetailsPanel />}
            {tab === 'users' && <OrganisationUserPanel />}
            {tab === 'projects' && <OrganisationProjectsPanel />}
            {tab === 'teams' && <OrganisationTeamsPanel />}
            {tab === 'workspaces' && <OrganisationWorkspacesPanel />}
          </div>
        </div>
      )}
    </div>
  )
}
